import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Modal, Box, Typography, IconButton, Grid, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InputField from '../../../../common/components/FormFields/InputField';
import CommonButton from '../../../../common/components/Buttons/CommonButton';
import { ForceCloseIcon } from '../../../../assets/CommonAssets';
import { saveTemplateMaster } from '../../../services/emrTemplateServices/EMRTemplateServices';
import { errorAlert, successAlert } from '../../../../common/components/Toasts/CustomToasts';
// Import your custom components here
// import InputField from './InputField'; 
// import CommonButton from './CommonButton'; 

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: 700 },
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 2,
    p: 1,
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '90vh',
};

const NewTemplateModal = ({ setOpenModal, selectedRow, selectedId, selectedFieldId, getHopi, getGeneralExaminations, setSelectedFieldId, open, onClose, }) => {
    // Initialize form controls and default schema values
    const { control, handleSubmit, reset, watch } = useForm({
        defaultValues: {
            templateName: '',
            rs: '',
            cvs: '',
            cns: '',
            pa: '',
            other: '',
            amount: ''
        }
    });

    const [openBackDrop, setOpenBackdrop] = useState(false);
    const watchTemplateName = watch('templateName');
    let getRS = watch("rs");
    let getCVS = watch("cvs");
    let getCNS = watch("cns");
    let getPA = watch("pa");
    let getOther = watch("other");

    const onSubmit = () => {
        const obj = {
            templateName: watchTemplateName,
            templateFieldId: selectedFieldId ? selectedFieldId : null,
            description:
                selectedFieldId === 4
                    ? getHopi
                    : selectedFieldId === 10
                        ? getGeneralExaminations
                        : "",
            doctorId: selectedRow?.["Doctor Id"] ? selectedRow?.["Doctor Id"] : null,
            id: selectedId !== null ? selectedId : null,
            rs: getRS !== "" ? getRS : "",
            cvs: getCVS !== "" ? getCVS : "",
            cns: getCNS !== "" ? getCNS : "",
            other: getOther !== "" ? getOther : "",
            pa: getPA !== "" ? getPA : ""
        };
        setOpenBackdrop(true);

        console.log(obj, "objobjobjobjobjobjobjobjobj");
        saveTemplateMaster(obj)
            .then((response) => response.data)
            .then((res) => {
                if (res.statusCode === 201 || res.statusCode === 200) {
                    setOpenModal(false);
                    // populateTable();
                    successAlert(res?.message);
                    reset();
                    setOpenBackdrop(false);
                    setSelectedFieldId(null);
                }
            })
            .catch((error) => {
                // console.log("error", error);
                setOpenModal(false);
                errorAlert(error?.message);
                setOpenBackdrop(false);
            });
    };

    return (
        <Modal open={open} >
            <Box sx={modalStyle} component="form" onSubmit={handleSubmit(onSubmit)}>

                {/* Modal Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center" >
                    <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', pl: "8px" }}>
                        New Template
                    </Typography>
                    <IconButton onClick={() => {
                        onClose()
                    }} size="small" edge="end">
                        <ForceCloseIcon />
                    </IconButton>
                </Box>

                {/* Modal Body */}
                <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
                    {/* Primary Template Name Field */}



                    <Box sx={{ flexGrow: 1, overflowY: 'auto', }}>



                        <Grid size={{ xs: 12, sm: 4 }} sx={{ p: 1 }}> {/* p: 1 adds uniform gaps around every item */}
                            <InputField
                                control={control}
                                name="templateName"
                                label="Template Name"
                                placeholder="Enter template na me..."
                            />

                        </Grid>



                        {/* Using an explicit container style to force horizontal and vertical gaps */}
                        <Grid container spacing={0}>
                            <Grid size={{ xs: 12, sm: 4 }} sx={{ p: 1 }}> {/* p: 1 adds uniform gaps around every item */}
                                <InputField
                                    control={control}
                                    name="rs"
                                    label="RS"
                                    placeholder="Respiratory System..."
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 4 }} sx={{ p: 1 }}>
                                <InputField
                                    control={control}
                                    name="cvs"
                                    label="CVS"
                                    placeholder="Cardiovascular..."
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 4 }} sx={{ p: 1 }}>
                                <InputField
                                    control={control}
                                    name="cns"
                                    label="CNS"
                                    placeholder="Central Nervous..."
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 4 }} sx={{ p: 1 }}>
                                <InputField
                                    control={control}
                                    name="pa"
                                    label="PA"
                                    placeholder="Physical Assessment..."
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 4 }} sx={{ p: 1 }}>
                                <InputField
                                    control={control}
                                    name="other"
                                    label="Other"
                                    placeholder="Other findings..."
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Box>

                {/* Modal Footer containing unified Custom Buttons */}
                <div className='flex justify-end gap-2'>
                    <CommonButton
                        label={"Reset"}
                        type="button"
                        onClick={() => reset()} // Form state values instantly clear back to defaults
                        className={"border border-customRed text-customRed rounded px-2 py-0.5 text-xs"}
                    />
                    <CommonButton
                        label={"Save"}
                        type="submit"
                        // disabled={!watchTemplateName?.trim()}
                        className={"bg-customGreen text-white rounded px-2 py-0.5 text-xs"}
                    />
                </div>

            </Box>
        </Modal>
    );
};

export default NewTemplateModal;